import React from "react";
import { Box, HStack, VStack, Icon, Link, SimpleGrid, Text, Divider } from "@chakra-ui/react";
import { NavLink } from "react-router-dom";
import { FaEnvelope, FaHome, FaInfoCircle, FaHistory, FaBook } from "react-icons/fa";
import Logo from "@ui/assets/common/Logo";
import { PROJECT_NAME, CURRENT_YEAR, SUPPORT_EMAIL, COMPANY_NAME } from "@constants";
import { colors } from "@theme/tokens";

const quickLinks = [
  { label: "Workspace", to: "/workspace", icon: FaHome },
  { label: "Аналитика", to: "/analytics", icon: FaHistory },
  { label: "Правила", to: "/marketplace", icon: FaBook },
  { label: "О проекте", to: "/info", icon: FaInfoCircle },
];

function FooterLink({ to, children, icon }) {
  return (
    <Link
      as={NavLink}
      to={to}
      display="flex"
      alignItems="center"
      gap={2}
      fontSize="sm"
      color={colors.text.tertiary}
      _hover={{ color: colors.brand.primary }}
    >
      {icon && (
        <Box
          w="20px"
          h="20px"
          borderRadius="full"
          display="inline-flex"
          alignItems="center"
          justifyContent="center"
          bg="rgba(255,255,255,0.06)"
          border="1px solid"
          borderColor="rgba(255,255,255,0.11)"
          transition="all 0.2s"
        >
          <Icon as={icon} boxSize={2.5} />
        </Box>
      )}
      {children}
    </Link>
  );
}

function Footer() {
  return (
    <Box as="footer" bg={colors.background.card} borderTop="1px solid" borderColor={colors.border.default}>
      <Box maxW="1400px" mx="auto" px={{ base: 4, md: 6, lg: 8 }} py={{ base: 10, md: 12 }}>
        <SimpleGrid columns={{ base: 1, md: 3 }} spacing={8}>
          <VStack align={{ base: "center", md: "flex-start" }} spacing={4}>
            <HStack spacing={3}>
              <Logo boxSize={7} variant="solid" />
              <VStack align="flex-start" spacing={0}>
                <Text fontWeight="bold" fontSize="xl" color={colors.brand.primary}>{PROJECT_NAME}</Text>
                <Text fontSize="10px" letterSpacing="0.15em" textTransform="uppercase" color={colors.text.tertiary}>LEGAL AI PIPELINE</Text>
              </VStack>
            </HStack>
            <Text fontSize="sm" color={colors.text.tertiary} maxW="320px" textAlign={{ base: "center", md: "left" }}>
              Платформа для проверки рекламных коммуникаций на юридические риски.
            </Text>
          </VStack>

          <VStack align={{ base: "center", md: "flex-start" }} spacing={3}>
            <Text fontSize="xs" fontWeight="semibold" color={colors.text.secondary} textTransform="uppercase">Навигация</Text>
            {quickLinks.map((link) => (
              <FooterLink key={link.to} to={link.to} icon={link.icon}>{link.label}</FooterLink>
            ))}
          </VStack>

          <VStack align={{ base: "center", md: "flex-start" }} spacing={3}>
            <Text fontSize="xs" fontWeight="semibold" color={colors.text.secondary} textTransform="uppercase">Контакты</Text>
            <Link href={`mailto:${SUPPORT_EMAIL}`} display="flex" alignItems="center" gap={2} fontSize="sm" color={colors.text.tertiary} _hover={{ color: colors.brand.primary }}>
              <Icon as={FaEnvelope} boxSize={3} />
              {SUPPORT_EMAIL}
            </Link>
            <Text fontSize="xs" color={colors.text.tertiary}>Поддержка проекта {COMPANY_NAME}</Text>
          </VStack>
        </SimpleGrid>

        <Divider borderColor={colors.border.subtle} my={6} />
        <HStack justify="space-between" flexWrap="wrap" gap={3}>
          <Text fontSize="xs" color={colors.text.muted}>© {CURRENT_YEAR} {COMPANY_NAME}. Все права защищены. При копировании необходимо упоминание.</Text>
          <Text fontSize="xs" color={colors.text.muted}>Для юридических и бизнес-команд</Text>
        </HStack>
      </Box>
    </Box>
  );
}

export default Footer;
